import api from "../utils/api";
import { LOGOUT } from "./types";

export const get = ({ personUuid, roleUuid, start, end }) => async (dispatch) => {
    try {
        const res = await api.get(`/v1/roles/availability/u/${personUuid}/r/${roleUuid}/${start}/${end}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};

export const save = (payload) => async (dispatch) => {
    try {
        const res = await api.post(`/v1/roles/availability`, payload);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};

export const destroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.delete(`/v1/roles/availability/i/${uuid}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};

export const copy = ({ personUuid, roleUuid, sourceDate, targetDates }) => async (dispatch) => {
    try {
        const res = await api.post(`/v1/roles/availability/copy`, {
            personUuid,
            roleUuid,
            sourceDate,
            targetDates,
        });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};